<section *ngIf="myself" class="user-settings-transactions" [attr.aria-labelledby]="'transactions-heading'">
  <app-cr-header id="transactions-heading" [headingLevel]="2">
    {{ 'USER_SETTINGS.USER_SETTINGS_TRANSACTIONS' | translate }}
  </app-cr-header>

  <div
    *ngIf="(loadingPurchaseList$ | async) === false && (purchaseList$ | async)?.length && showPurchaseList"
    class="purchases-list">
    <nz-collapse>
      <nz-collapse-panel
        *ngFor="let purchase of purchaseList$ | async; index as purchaseIndex"
        [nzHeader]="PurchaseHeader"
        [attr.aria-labelledby]="'purchase-' + purchaseIndex">
        <ng-template #PurchaseHeader>
          <span>
            {{ 'PURCHASE.TRANSACTION_DATE' | translate }}
            <b>{{ purchase.updatedAt | date: 'yyyy-MM-dd HH:mm' }}</b>
          </span>
          &nbsp; &nbsp;
          <span *ngIf="purchase.status === PurchaseStatus.CLOSED">
            {{ 'PURCHASE.TOTAL_AMOUNT_PAID' | translate }}
            <b>{{ (purchase.totalAmountPaid / 100).toFixed(2) }} PLN</b>
          </span>
          <span *ngIf="purchase.status !== PurchaseStatus.CLOSED">
            {{ 'PURCHASE.TRANSACTION_NOT_FINISHED' | translate }}
          </span>
        </ng-template>
        <ul *ngIf="purchase.paymentInfo.p24_transactionInfo as transactionInfo" role="presentation">
          <li class="item">
            <div class="app-list-item">
              <b>{{ 'PURCHASE.TRANSACTION_STATEMENT_VISIBLE_IN_BANK_ACCOUNT_HISTORY' | translate }}</b>
            </div>
            <div class="app-list-item">
              {{ transactionInfo.statement }}
            </div>
          </li>
          <li class="item">
            <div class="app-list-item">
              <b>{{ 'PURCHASE.TRANSACTION_AMOUNT' | translate }}</b>
            </div>
            <div class="app-list-item">
              {{ (purchase.totalAmountPaid / 100).toFixed(2) }} {{ purchase.paymentInfo.currency }}
            </div>
          </li>
          <li class="item">
            <div class="app-list-item">
              <b>{{ 'PURCHASE.TRANSACTION_CURRENCY' | translate }}</b>
            </div>
            <div class="app-list-item">
              {{ purchase.paymentInfo.currency }}
            </div>
          </li>
        </ul>
        <ul *ngIf="purchase.products?.length">
          <li class="item">
            <div class="app-list-item">
              <b>{{ 'PURCHASE.PURCHASED_SERVICES' | translate }}</b>
            </div>
            <div
              *ngFor="let product of purchase.products"
              class="app-list-item"
              role="text"
              [attr.aria-label]="
                product.name[currentLang] + ', ' + ('COMMON.LABEL.QUANTITY' | translate) + ' ' + product.quantity
              ">
              <span aria-hidden="true"> {{ product.name[currentLang] }} x{{ product.quantity }} </span>
            </div>
          </li>
        </ul>
        <ul *ngIf="purchase.userProcesses?.length">
          <li class="item">
            <div class="app-list-item">
              <b>{{ 'PURCHASE.SERVICES_IN_PROGRESS' | translate }}</b>
            </div>

            <div class="app-list-item" *ngFor="let app of purchase.userProcesses">
              <ng-container *ngIf="app.status === UserProcessStatus.ARCHIVED; else UserProcessLink">
                <span class="archived-item" [attr.aria-hidden]="true">
                  {{ 'APPLICATION.APPLICATION' | translate }}
                  {{ app.name }}
                  <ng-container *ngIf="app.personalDetails?.name || app.personalDetails?.surname">
                    -
                    {{ app.personalDetails.name }}
                    {{ app.personalDetails.surname }}
                  </ng-container>
                </span>
              </ng-container>

              <ng-template #UserProcessLink>
                <a
                  class="in-app-link"
                  [routerLink]="['/user-process', app.id]"
                  [attr.aria-label]="
                    ('APPLICATION.APPLICATION' | translate) +
                    ' ' +
                    app.name +
                    (app.personalDetails?.name || app.personalDetails?.surname
                      ? ' - ' + app.personalDetails?.name + ' ' + app.personalDetails?.surname
                      : '') +
                    ', ' +
                    (app.hasFullHandling
                      ? ('COMMON.LAYOUT.HAS_FULL_HANDLING' | translate)
                      : app.hasAssistantService
                      ? ('COMMON.LAYOUT.HAS_ASSISTANT_SERVICE' | translate)
                      : ('COMMON.LAYOUT.HAS_BASIC_SUPPORT' | translate)) +
                    (app.status === UserProcessStatus.ARCHIVED ? ', ' + ('COMMON.GENERAL.ARCHIVED' | translate) : '')
                  ">
                  {{ 'APPLICATION.APPLICATION' | translate }}
                  {{ app.name }}
                  <ng-container *ngIf="app.personalDetails?.name || app.personalDetails?.surname">
                    -
                    {{ app.personalDetails.name }}
                    {{ app.personalDetails.surname }}
                  </ng-container>
                </a>
              </ng-template>

              <span [attr.aria-hidden]="true">&nbsp;-&nbsp;</span>

              <app-service-level-tag
                [userProcess]="app"
                [mode]="PurchaseTags.LARGE"
                [attr.aria-hidden]="true"></app-service-level-tag>

              <ng-container *ngIf="app.status === UserProcessStatus.ARCHIVED">
                <span [attr.aria-hidden]="true"> &nbsp; - &nbsp; {{ 'COMMON.GENERAL.ARCHIVED' | translate }} </span>
              </ng-container>
            </div>
          </li>

          <li class="action-button">
            <button
              *ngIf="purchase.purchaseDocumentId"
              type="button"
              nz-button
              nzType="primary"
              (click)="downloadPurchaseDocument(purchase.purchaseDocumentId)">
              {{ 'PURCHASE.DOWNLOAD_PURCHASE_DOCUMENT' | translate }}
            </button>
            <span *ngIf="!purchase.purchaseDocumentId">
              {{ 'PURCHASE.PURCHASE_DOCUMENT_NOT_AVAILABLE' | translate }}
            </span>
          </li>
        </ul>
      </nz-collapse-panel>
    </nz-collapse>
  </div>
  <div
    *ngIf="(loadingPurchaseList$ | async) === false && (purchaseList$ | async)?.length === 0"
    class="empty-purchases-list">
    <nz-empty></nz-empty>
  </div>
  <div
    *ngIf="(loadingPurchaseList$ | async) === true"
    class="loading-container-in-section"
    role="status"
    aria-live="polite">
    <span class="sr-only">
      {{ 'COMMON.LAYOUT.LOADING' | translate }}
    </span>

    <mat-spinner [diameter]="50" [attr.aria-hidden]="true"></mat-spinner>

    <div class="spinner-message" [innerHTML]="'USER_SETTINGS.LOADING_PURCHASE_HISTORY' | translate"></div>
  </div>
</section>
